import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const apply = () => {
      const p = sessionStorage.getItem("preventivo");
      if (p) {
        setForm((f) => ({ ...f, message: p }));
        sessionStorage.removeItem("preventivo");
      }
    };
    apply();
    window.addEventListener("preventivo:set", apply);
    return () => window.removeEventListener("preventivo:set", apply);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato! Ti ricontattiamo entro 24 ore.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-black/15 bg-white px-5 py-3.5 text-sm text-neutral-800 placeholder:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-neutral-900 transition-shadow";

  return (
    <section id="contatti" data-testid="contact-section" className="py-24 lg:py-32 bg-white border-t border-black/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="mono-label text-[#E05638] mb-6">06 // Contatti</p>
          <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Parliamone di persona.
          </h2>
          <p className="mt-6 text-neutral-600 leading-relaxed max-w-md">
            Raccontaci il tuo progetto: ti rispondiamo entro 24 ore con una proposta su misura e
            una call conoscitiva gratuita.
          </p>
          <div className="mt-10 space-y-4">
            <div>
              <p className="mono-label text-neutral-500">Email</p>
              <p className="font-medium mt-1.5">lumoratech.it@gmail.com</p>
            </div>
            <div>
              <p className="mono-label text-neutral-500">Studio</p>
              <p className="font-medium mt-1.5">Novara · Operiamo in tutta Italia</p>
            </div>
          </div>
        </div>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7 bg-[#FAF8F5] border border-black/10 rounded-2xl p-8 sm:p-10 space-y-5"
        >
          <div className="grid sm:grid-cols-2 gap-5">
            <input
              data-testid="contact-form-name"
              required
              placeholder="Il tuo nome"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className={inputCls}
            />
            <input
              data-testid="contact-form-email"
              required
              type="email"
              placeholder="La tua email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className={inputCls}
            />
          </div>
          <textarea
            data-testid="contact-form-message"
            required
            rows={5}
            placeholder="Raccontaci il tuo progetto…"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className={`${inputCls} resize-none`}
          />
          <button
            data-testid="contact-form-submit-button"
            type="submit"
            disabled={sending}
            className="inline-flex items-center gap-2 rounded-full bg-[#111111] text-white px-8 py-3.5 text-sm font-semibold hover:bg-[#E05638] transition-colors duration-300 disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:ring-offset-2"
          >
            {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
            Invia richiesta
          </button>
        </motion.form>
      </div>
    </section>
  );
}
